import { Badge } from "@/components/ui/badge";

const map = {
  active: "bg-emerald-500 text-white",
  pending_approval: "bg-yellow-400 text-yellow-950",
  pending: "bg-yellow-400 text-yellow-950",
  suspended: "bg-red-500 text-white",
  rejected: "bg-red-500 text-white",
  confirmed: "bg-blue-600 text-white",
  completed: "bg-emerald-500 text-white",
  cancelled: "bg-slate-400 text-white",
  cancelled_by_staff: "bg-slate-400 text-white",
  cancelled_by_company: "bg-slate-400 text-white",
  no_show: "bg-red-500 text-white",
  published: "bg-blue-600 text-white",
  draft: "bg-slate-300 text-slate-800",
  paused: "bg-yellow-400 text-yellow-950",
  approved: "bg-emerald-500 text-white",
  expired: "bg-slate-400 text-white",
};

export default function StatusBadge({ status, className = "" }) {
  const cls = map[status] || "bg-slate-200 text-slate-800";
  const label = String(status || "—").replace(/_/g, " ");
  return (
    <span className={`inline-flex items-center rounded-md px-2.5 py-0.5 text-xs font-semibold capitalize ${cls} ${className}`}>
      {label}
    </span>
  );
}
